import { FC, useState } from "react";
import { User } from "src/api/types";

import UserDataTab from "./accountUserData";
import UserDocsTab from "./accountUserDocs";
import UserEventsTab from "./accountUserEvents";
import UserConsentTab from "./accountUserConsent";
import UserQuestionnaireTab from "./accountUserQuestionnaire";
import { permissions } from "src/lib/constants";
import UserActivityLogsTab from "./accountUserActivityLogs";

type Props = {
  user: User;
};

const UserAccountInfoPage: FC<Props> = ({ user }) => {
  const [activeTab, setActiveTab] = useState("data");

  const renderTab = () => {
    switch (activeTab) {
      case "data":
        return <UserDataTab user={user} />;
      case "docs":
        return <UserDocsTab user={user} />;
      case "events":
        return <UserEventsTab user={user} />;
      case "consent":
        return <UserConsentTab user={user} />;
      case "questionnaire":
        return <UserQuestionnaireTab user={user} />;
      case "activityLogs":
        return <UserActivityLogsTab user={user} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-r-[12px] rounded-bl-[12px] w-full">
      <div className="p-4">
        {/* Header */}
        <div className="border-b pb-4">
          {/* <p className="text-primary font-manrope text-[18px] font-medium">
            User Account
          </p> */}

          {/* Tabs */}
          <div className="flex gap-6 mt-4">
            <button
              className={`pb-2 ${
                activeTab === "data"
                  ? "border-b-2 border-blue-500 font-semibold"
                  : ""
              }`}
              onClick={() => setActiveTab("data")}
            >
              User Data
            </button>

            {permissions?.KYC_INFO && (
              <>
                <button
                  className={`pb-2 ${
                    activeTab === "docs"
                      ? "border-b-2 border-blue-500 font-semibold"
                      : ""
                  }`}
                  onClick={() => setActiveTab("docs")}
                >
                  User Docs
                </button>
                <button
                  className={`pb-2 ${
                    activeTab === "events"
                      ? "border-b-2 border-blue-500 font-semibold"
                      : ""
                  }`}
                  onClick={() => setActiveTab("events")}
                >
                  User Events
                </button>
                <button
                  className={`pb-2 ${
                    activeTab === "consent"
                      ? "border-b-2 border-blue-500 font-semibold"
                      : ""
                  }`}
                  onClick={() => setActiveTab("consent")}
                >
                  User Consent
                </button>
                <button
                  className={`pb-2 ${
                    activeTab === "questionnaire"
                      ? "border-b-2 border-blue-500 font-semibold"
                      : ""
                  }`}
                  onClick={() => setActiveTab("questionnaire")}
                >
                  Questionnaire
                </button>

                <button
                  className={`pb-2 ${
                    activeTab === "activityLogs"
                      ? "border-b-2 border-blue-500 font-semibold"
                      : ""
                  }`}
                  onClick={() => setActiveTab("activityLogs")}
                >
                  User Activity Logs
                </button>
              </>
            )}
          </div>
        </div>

        {/* Tab Content */}
        <div className="mt-6">{renderTab()}</div>
      </div>
    </div>
  );
};

export default UserAccountInfoPage;
